Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, "product-details-photo-gallery", function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.x-product-details-photo-gallery', $context);

        if ($control.length < 1)
            return;

        if ($control.hasClass('with-slider')) {
            cleanThumbGallery();
            cleanPhotoGallery();
            initCarousel();
        } else {
            stickyAnchors();
            $(window).scroll($.throttle(100, stickyAnchors));
            scrollToGallery();                     
            initGalleryAnchors();

            //init and destroy carousel
            manipulateCarousel();
        }
        
        initCZ();       
        initFB();
        initSpinner();

        function initCZ() {
            var $image = $('.js-image-container', $control);

            if ($image.length < 1)
                return;

            var $cz = $('.cloud-zoom, .cloud-zoom-gallery', $control),
                $fb = $('.pd-fancybox', $control);

            var czOpts = {
                transparentImage: 'data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
                useWrapper: true,
                adjustY: 0,
                adjustX: 90,
                position: 'inside',
                showTitle: false,
            };

            var fbOpts = {};

            if ($fb.length > 0) {
                $fb.fancybox(fbOpts);
            } else {
                if (!isTouch()) {
                    $cz.click(function (e) {
                        e.preventDefault();
                        $(this).CloudZoom(czOpts);
                    });
                } else {
                    $cz.on('click', function (e) {
                        e.preventDefault();
                        var $slideWrapper = $('.swiper-initialized');
                        if ($slideWrapper.length > 0) {
                            $('.swiper-slide-active', $slideWrapper).children('.pd-fancybox-gallery').trigger('click');
                        }
                    });
                }
            }
        }

        function initCarousel() {

            var $thumbs = $('.gallery-thumbs', $control);
            var $thumbsCont = $thumbs.parent();
            var $mainGallery = $('.main-gallery', $control);

            var numOfSlides = $('.swiper-wrapper > li', $thumbs).length;

            if (numOfSlides < 1)
                return;

            function waitForImageToLoad(imageElement) {
                return new Promise(function (resolve, reject) {
                    imageElement.onload = resolve;
                });
            }

            var newImg = $mainGallery.get(0).querySelector('.gallery-item.first img');
            if (newImg.complete) {
                initialization();
            } else {
                waitForImageToLoad(newImg).then(function () {
                    initialization();
                });
            }

            function initialization() {
                var sliderThumbs = new Swiper('.gallery-thumbs', {
                    slideToClickedSlide: true,
                    watchSlidesProgress: true,
                    direction: 'vertical',
                    slidesPerView: "auto",
                    threshold: 5,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                });
                var sliderMain = new Swiper('.main-gallery', {
                    threshold: 5,
                    autoHeight: true,
                    slideToClickedSlide: true,
                    watchSlidesProgress: true,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    breakpoints: {
                        1199: { simulateTouch: false }
                    },

                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },

                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    },

                    thumbs: {
                        swiper: sliderThumbs,
                    },
                    on: {
                        init: function () {
                            var $slides = $('.main-gallery > ul > li');
                            $slides.each(function (index) {
                                var $slide = $(this);
                                $slide.attr('data-index', index);
                            })
                        },
                    },
                });

                sliderMain.on('slideChange', function () {
                    var $currentSlide = $(".main-gallery > ul > li[data-index='" + this.previousIndex + "']");
                    var hasVideo = $('.video-container', $currentSlide).length > 0;
                    var videoInitialized = $('iframe', $currentSlide).length > 0;

                    if (hasVideo && videoInitialized) {
                        var YTvideo = YT.get($('iframe', $currentSlide).attr('id'));
                        //pause video
                        YTvideo.pauseVideo();
                    }
                });

            }
        }

        function destroyCarousel() {
            var $thumbs = $('.gallery-thumbs', $control);
            var $mainGallery = $('.main-gallery', $control);

            if ($thumbs.hasClass('swiper-initialized')) {
                sliderThumbs.destroy(true, true);
                $('.swiper-wrapper', $thumbs).removeAttr('style');
                $('.swiper-slide', $thumbs).removeAttr('style');
            }
            if ($mainGallery.hasClass('swiper-initialized')) {
                sliderMain.destroy(true, true);
                $('.swiper-wrapper', $mainGallery).removeAttr('style');
                $('.swiper-slide', $mainGallery).removeAttr('style');
            } 
        }

        function manipulateCarousel() {

            var $swiperInitialized = $('.main-gallery', $control).hasClass('swiper-initialized');

            if (isTouch() && $(window).outerWidth() < 960) {
                if (!$swiperInitialized) {
                    initCarousel();
                    $swiperInitialized = true;
                } 
            } else {
                destroyCarousel();
                $swiperInitialized = false;
            }

            $(window).resize($.debounce(100, function () {
                if (isTouch() && $(window).outerWidth() < 960) {
                    if (!$swiperInitialized) {
                        initCarousel();
                        $swiperInitialized = true;
                    } 
                } else {
                    destroyCarousel();
                    $swiperInitialized = false;
                }
            }));
        }

        function initFB() {

            var $fancyLinks = $('.pd-fancybox-gallery', $control);
            var $mainGallery = $('.main-gallery', $control);

            if ($fancyLinks.length < 1) return;

            var fbOpts = {
                protect: true,
                infobar: true,
                mobile: {
                    clickSlide: function (current, event) {
                        return "close";
                    }
                }
            };

            $fancyLinks.fancybox(fbOpts);

            $control.on('click', '.fancy-btn', function (e) {

                if ($control.hasClass('with-slider')) {
                    var $slideWrapper = $('.swiper-wrapper', $mainGallery);
                    if ($slideWrapper.length > 0) {
                        $('.swiper-slide-active', $slideWrapper).children('.pd-fancybox-gallery').trigger('click');
                    }
                } else {
                    $('.gallery-item', $mainGallery).first().children('.pd-fancybox-gallery').trigger('click');
                }
                
            });
        }

        function initSpinner() {
            var $spinner = $('.spritespin', $control);

            if ($spinner.length < 1)
                return;

            $control.children('script').remove();

            $spinner.each(function (index) {
                var $this = $(this);

                var spinnerSlider = $(this).siblings('.spinner-slider');

                $this.siblings('script').remove();
                $this.spritespin({
                    source: spinnerData[index],
                    animate: false,
                    sense: -1,
                    sizeMode: 'fit',
                    responsive: true,
                    plugins: [
                        'progress',
                        '360',
                        'drag'
                    ],
                    onInit: function () {
                        spinnerSlider.ionRangeSlider({
                            skin: "big",
                            min: 0,
                            max: spinnerData[index].length - 1,
                            hide_min_max: true,
                            hide_from_to: true,
                            onChange: function (data) {
                                $this.spritespin('api').updateFrame(data.from);
                            }
                        });
                    },
                });
            });
        }

        function cleanThumbGallery() {
            var $colorThumbs, $photoThumbs;

            $colorThumbs = $('.color-thumb', $control);
            $photoThumbs = $('.photo-thumb', $control);

            cleanImage($colorThumbs, $photoThumbs);
        }

        function cleanPhotoGallery() {
            var $colorItems, $photoItems;

            $colorItems = $('.color-item', $control);
            $photoItems = $('.photo-item', $control);

            cleanImage($colorItems, $photoItems);
        }

        function cleanImage($colors, $photos) {
            $colors.each(function (index, item) {
                var $item, $thumb, colorSrc, src, founded;

                $item = $(item);
                colorSrc = $('img', $item).attr('src');
                founded = false;


                $photos.each(function (index, elem) {
                    $elem = $(elem);

                    src = $('img', $elem).attr('src');

                    if (colorSrc === src) {
                        $elem.closest('li').remove();
                        founded = true;
                        return false;
                    }
                });

                if (founded)
                    return false;
            });
        }

        function stickyAnchors() {

            if ($(window).outerWidth() < 960) return;

            var $wrapper = $('.x-pd-gallery-thumbs');
            var $stickyBarHeight = $('.header-region').height();

            if ($(window).scrollTop() < $stickyBarHeight) {
                $wrapper.removeClass('sticky');
            } else {
                $wrapper.addClass('sticky');
            }
        }

        function scrollToGallery() {

            if ($(window).outerWidth() < 960) return;

            var $container = $('.gallery-thumbs', $control);
            var $anchor = $('.thumb-item', $container);
            var $stickyBarHeight = $('.sticky-header-region').height() || 0;

            $anchor.click(function () {
                var $thisAnchor = $(this);
                var $thumbIndex = $thisAnchor.index();
                var $sectionToScroll = $('.gallery-item:eq(' + $thumbIndex + ')');

                $('html, body').animate({ scrollTop: $sectionToScroll.offset().top - $stickyBarHeight }, 400);               
            });

        }

        function initGalleryAnchors() {

            if ($(window).outerWidth() < 960) return;

            var $container = $('.gallery-thumbs', $control);
            var $anchor = $('.thumb-item', $container);
            var $contentContainer = $('.main-gallery', $control);
            var $content = $('.gallery-item', $contentContainer);
            var $stickyBarHeight = $('.sticky-header-region').height() || 0;
            var offsetArray = [];
            var isLastElement = false;
            var firstScroll = true; 

            //set first item active
            $anchor.first().addClass('current');

            //unbind scroll using specific event name
            $(window).off("scroll.event");
            //bind scroll using specific event name
            $(window).on('scroll.event', function () {

                if (firstScroll) {
                    //Add offsets to an Array
                    $content.each(function (content, index) {
                        offsetArray.push($(content).offset().top - ($stickyBarHeight + 1));
                    });
                }

                //Enable every anchor when scroll is in appropriate height
                offsetArray.forEach(function (offset, index) {

                    if (index == offsetArray.length - 1) {
                        isLastElement = true;
                    } else {
                        isLastElement = false;
                    }

                    if (isLastElement) {
                        if ($(window).scrollTop() >= offsetArray[index]) {
                            $anchor.removeClass('current');
                            $('li.thumb-item:eq(' + index + ')').addClass('current');
                        }
                    } else {
                        if ($(window).scrollTop() >= offsetArray[index] && $(window).scrollTop() < offsetArray[index + 1]) {
                            $anchor.removeClass('current');
                            $('li.thumb-item:eq(' + index + ')').addClass('current');
                        }
                    }
                });

                firstScroll = false;
            });
            
        } 
    });

});

function deleteSpinnerInstances() {
    var spinners = $(".x-product-details .spritespin");

    if (spinners.length < 1)
        return;

    spinners.spritespin("destroy");
}
